import {
  get,
  post,
  put,
  del,
  getWithStatusCodeFirebase
} from '../configApi';
// active
export async function updateExamActive(body) {
  return await put(`/exam/manage/active`, body)
}

// exam
export async function insertExam(body) {
  return await post(`/exam/manage/insert`, body)
}
export async function updateExam(body) {
  return await put(`/exam/manage/update`, body)
}
export async function updateExamRandomChoice(body) {
  return await put(`/exam/manage/updaterandomchoice`, body)
}

export async function getQuestionList(params) {
  return await get(`/exam/question/list/admin`, params)
}
export async function getExamById(params) {
  return await get(`/exam/detail/admin`, params)
}

// choice
export async function insertChoice(body) {
  return await post(`/exam/question/choice/manage/insert`, body)
}
export async function updateChoice(body) {
  return await put(`/exam/question/choice/manage/update`, body)
}

// question
export async function insertQuestion(body) {
  return await post(`/exam/question/manage/insert`, body)
}
export async function updateQuestion(body) {
  return await put(`/exam/question/manage/update`, body)
}
export async function deleteQuestion(body) {
  return await del(`/exam/question/manage/delete`, body)
}
export async function deleteQuestionAll(body) {
  return await post(`/exam/question/manage/deleteall`, body)
}
export async function reorderQuestion(body) {
  return await put(`/exam/manage/setquestion`, body)
}
export async function getQuestionById(body) {
  return await get('/exam/question/detail/admin', body)
}
export async function shiftquestion(body) {
  return await put(`/exam/manage/shiftquestion`, body)
}
export async function getQuestionArticleById(body) {
  return await get('/exam/question/list/questionarticle', body)
}
export async function getQuestionListSwap(body) {
  return await get('/exam/question/list/swapquestion', body)
}



// article
export async function insertArticle(body) {
  return await post(`/exam/question/article/manage/insert`, body)
}

// tag level
export async function insertTagLevel(body) {
  return await post(`/exam/taglevel/manage/insert`, body)
}
export async function updateTagLevel(body) {
  return await put(`/exam/taglevel/manage/update`, body)
}
export async function deleteTagLevel(body) {
  return await del(`/exam/taglevel/manage/delete`, body)
}
export async function getListTagLevel(body) {
  return await get('/exam/taglevel/list/admin', body)
}

export async function startStateAdmin(param){
  return await getWithStatusCodeFirebase('/startStateAdmin', param)
}

export async function getAdminTicketDetail(param){
  return await getWithStatusCodeFirebase('/startStateAdmin/detail', param)
}


